// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"424":"2c9fb281","443":"27f87240","844":"7860533b"}[chunkId] + ".css";
};